import { action } from 'typesafe-actions';
import {
    AssessmentState, GradingWorkflowDefinitionPhase, GradingWorkflowPhaseStatus, QuestionsAttachmentInfo,
} from './reducer';
import { ModerationPrimaryActions, ModerationStatus, WorkflowPrimaryActions } from '../context/types';

export enum ContextTypeKeys {
    ASSESSMENT_INFO_LOADED = 'ASSESSMENT_INFO_LOADED',
    UPDATE_GRADING_INFO = 'UPDATE_GRADING_INFO',
    UPDATE_ASSESSMENT_GRADING_PARTY_INFO = 'UPDATE_ASSESSMENT_GRADING_PARTY_INFO',
    UPDATE_EXPLANATION_DEADLINE = 'UPDATE_EXPLANATION_DEADLINE',
    ON_PRIMARY_ACTION_CLICK = 'ON_PRIMARY_ACTION_CLICK',
    HEADER_UPDATED = 'HEADER_UPDATED',
    GRADING_PARTY_INDEX_UPDATE = 'GRADING_PARTY_INDEX_UPDATE',
    USER_QUESTION_INDEX_UPDATE = 'USER_QUESTION_INDEX_UPDATE',
    USER_QUESTION_INDEX_CORRECTED_ANSWER_KEYS_UPDATE = 'USER_QUESTION_INDEX_CORRECTED_ANSWER_KEYS_UPDATE',
    SYNC_WITH_EXTERNAL_TEST = 'SYNC_WITH_EXTERNAL_TEST',
    SYNC_WITH_EXTERNAL_TEST_LOADING = 'SYNC_WITH_EXTERNAL_TEST_LOADING',
    AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
    ASSESSTMENT_RUN_QUESTIONS_UPDATE = 'ASSESSTMENT_RUN_QUESTIONS_UPDATE',
    TRANSFER_GRADES_LOADING = 'TRANSFER_GRADES_LOADING',
    LOAD_ASSESSMENT_QUESTIONS_ATTACHMENT_INFO = 'LOAD_ASSESSMENT_QUESTIONS_ATTACHMENT_INFO',
    ASSESSMENT_QUESTIONS_ATTACHMENT_INFO_LOADED = 'ASSESSMENT_QUESTIONS_ATTACHMENT_INFO_LOADED',
    ON_MODERATION_ACTION_CLICK = 'ON_MODERATION_ACTION_CLICK',
    GRADING_WORKFLOW_DEFINITION_LOADED = 'GRADING_WORKFLOW_DEFINITION_LOADED',
}

export interface SyncProps {
    externalSystem: string;
    totalNumberOfCandidates: number;
    totalNumberOfEvaluators: number;
    committees: number;
}

export const assessmentInfoLoaded = (assessmentInfo: AssessmentState) => action(ContextTypeKeys.ASSESSMENT_INFO_LOADED, assessmentInfo);

export const updateGradingInfo = (triggeringUser: number) => action(ContextTypeKeys.UPDATE_GRADING_INFO, triggeringUser);

export const updateGradingInfoWithGradingParty = (partyIds: []) => action(ContextTypeKeys.UPDATE_ASSESSMENT_GRADING_PARTY_INFO, partyIds);

export const updateExplanationDeadline = (newDeadline: string) => action(ContextTypeKeys.UPDATE_EXPLANATION_DEADLINE, newDeadline);

export const headerUpdated = () => action(ContextTypeKeys.HEADER_UPDATED);

export const gradingPartyIndexUpdate = (gradingPartiesIndexUpdate: number[]) => action(ContextTypeKeys.GRADING_PARTY_INDEX_UPDATE,
    gradingPartiesIndexUpdate);

export const userQuestionIndexUpdate = (userQuestionIndexUpdate: number[]) => action(ContextTypeKeys.USER_QUESTION_INDEX_UPDATE,
    userQuestionIndexUpdate);

export const onPrimaryActionClick = (actionName: WorkflowPrimaryActions, options?: any) => action(ContextTypeKeys.ON_PRIMARY_ACTION_CLICK, {
    actionName,
    options,
});

export const onModerationActionClick = (actionName: ModerationPrimaryActions, moderationStatus: ModerationStatus, comment?: string) => action(
    ContextTypeKeys.ON_MODERATION_ACTION_CLICK, { actionName, moderationStatus, comment }
);

export const isAuthenticationError = (authError: boolean) => action(ContextTypeKeys.AUTHENTICATION_ERROR, {
    authError,
});

export const assessmentRunQuestionsUpdate = () => action(ContextTypeKeys.ASSESSTMENT_RUN_QUESTIONS_UPDATE);

export const userQuestionIndexCorrectedAnswerKeysUpdate = () => action(ContextTypeKeys.USER_QUESTION_INDEX_CORRECTED_ANSWER_KEYS_UPDATE);

export const loadAssessmentQuestionsAttachmentInfo = () => action(ContextTypeKeys.LOAD_ASSESSMENT_QUESTIONS_ATTACHMENT_INFO);

export const assessmentQuestionsAttachmentInfoLoaded = (attachmentInfo: QuestionsAttachmentInfo) => action(
    ContextTypeKeys.ASSESSMENT_QUESTIONS_ATTACHMENT_INFO_LOADED, attachmentInfo
);

export const gradingWorkflowDefinitionLoaded = (
    definition: GradingWorkflowDefinitionPhase[],
    status?: string,
    phases?: GradingWorkflowPhaseStatus[]
) => action(
    ContextTypeKeys.GRADING_WORKFLOW_DEFINITION_LOADED,
    { definition, status, phases }
);
